import React, { useCallback } from 'react';
import {
  Box, Grid, IconButton, Tooltip,
} from '@mui/material';
import NumberFormatContext from 'components/CustomInputsInFormikContext/NumberFormat';
import { ReactComponent as Trash } from 'images/icons/trash.svg';
import AddIcon from '@mui/icons-material/Add';
import AutoCompleteContext from 'components/CustomInputsInFormikContext/AutoComplete';
import { useFormikContext } from 'formik';
import Error from 'components/Snack/Error';

function InputGroup({
  index, onRemove, onAdd, ponds, totalApportionmentValue,
}) {
  const {
    getFieldMeta, setFieldValue,
  } = useFormikContext();
  const pondsModal = getFieldMeta('pondsModal');

  const errorTotalAmountExceeded = Error();

  const pondsMapped = ponds?.map((item) => ({
    ...item.pond,
  }));

  const handlePartChange = useCallback((newValue) => {
    const updatedInstallment = parseFloat(newValue);

    const updatedInstallments = [...pondsModal.value];
    updatedInstallments[index] = {
      ...pondsModal.value[index],
      value: updatedInstallment,
    };

    const currentTotal = updatedInstallments.reduce(
      (acc, curr) => acc + curr.value,
      0,
    );

    if (currentTotal > totalApportionmentValue) {
      errorTotalAmountExceeded('Valor total excedido!');
      setFieldValue(`pondsModal[${index}].value`, pondsModal.value[index].value);
      return;
    }

    setFieldValue(`pondsModal[${index}].value`, updatedInstallment);
  }, [errorTotalAmountExceeded, index, pondsModal.value, setFieldValue, totalApportionmentValue]);

  return (
    <Box display="flex" width="100%" gap={2}>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <AutoCompleteContext
            label="Viveiro"
            name={`pondsModal.${index}.pond`}
            getOptionLabel={(option) => option.description}
            options={pondsMapped}
          />
        </Grid>
        <Grid item xs={6}>
          <NumberFormatContext
            name={`pondsModal.${index}.value`}
            label="Valor do rateiro"
            prefix="R$ "
            decimalScale={2}
            onValueChangeCallback={(value) => {
              handlePartChange(value);
            }}
          />
        </Grid>
      </Grid>
      <Grid
        item
        xs="auto"
        display="flex"
        alignItems="center"
        justifyContent="flex-end"
      >
        {index > 0 && (
          <Tooltip title="Remover">
            <IconButton sx={{ bgcolor: '#FFDAD6' }} size="large" onClick={onRemove}>
              <Trash style={{ width: 14, height: 14, color: '#B3261E' }} />
            </IconButton>
          </Tooltip>
        )}

        {index === 0 && (
          <Tooltip title="Adicionar">
            <IconButton sx={{ bgcolor: '#DBE5DE' }} onClick={onAdd}>
              <AddIcon sx={{ color: '#006E2D' }} />
            </IconButton>
          </Tooltip>
        )}
      </Grid>
    </Box>
  );
}

export default InputGroup;
